//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\
import { Download_Log_FIN } from 'src/app/Constants/Backlog/FIN/Download_Log_FIN';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Task_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/All-Task-FIN.interface';
import { Annexe } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';


@Component({
    selector: 'app-check-task-assig-fin',
    templateUrl: './check-task-assig-fin.component.html',
    styleUrls: ['./check-task-assig-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css', '../../../../../Styles/TasksGlobal.css'],
    standalone: false
})
export class CheckTaskAssigFINComponent implements OnInit {

  //-===================================== SECTION FORMS =====================================-\\

  //+===================== FORM REASON REJECT =====================+\\
  public FormReject: FormGroup = new FormGroup({
    ReasonText: new FormControl('', [Validators.required, Validators.minLength(5)])
  })

  //-========================= SECTION VARIABLES =========================-\\

  //+================== VARIABLES FOR TASK ==================+\\

  public Task_FIN: Task_FIN = {
    ID: 0,
    ID_WF: 0,
    ID_UR: -1,
    ID_Involved_User: 0,
    Status: 0,
    Date_Start: null,
    Name: '',
    NameUser: '',
    Route_Destination: '',
    Annexes: []
  };

  //+================== VARIABLES FOR PREVIEW ==================+\\
  public showPreview: boolean = false;
  public previewFileName: string = '';
  public previewFileUrl: string = '';
  public previewFileExtension: string = '';

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;



  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  @Input('idT') ID_Task: number = 0;

  public librarySlug: string = 'fin';
  public libraryName: string = 'Processes';
  public baseRoute: string = '/Dashboard/FIN';


  //-========================= SERVICES =========================-\\

  private router = inject(Router);
  private activatedRouter = inject(ActivatedRoute)
  private Service_FIN = inject(LibraryFINService);

  private NavigateToTasksList(): void {
    this.router.navigate(['Dashboard/FIN/SeeAllTasksLibFIN'], {
      queryParams: {
        LibrarySlug: this.librarySlug,
        LibraryName: this.libraryName,
        BaseRoute: this.baseRoute
      }
    });
  }
  ngOnInit(): void {
    this.activatedRouter.queryParams.subscribe((params) => {
      this.librarySlug = String(params['LibrarySlug'] || 'fin').toLowerCase();
      let rawName = String(params['LibraryName'] || (this.librarySlug === 'fin' ? 'Processes' : this.librarySlug.toUpperCase()));
      if (rawName === 'Finance Processes') {
        rawName = 'Processes';
      }
      this.libraryName = rawName;
      this.baseRoute = String(params['BaseRoute'] || '/Dashboard/FIN');
      this.Load_Component_Task();
    });

  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_Task(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResTask: any = await firstValueFrom(this.Service_FIN.Get_Info_Of_Task(this.ID_Task, this.librarySlug));

      if (ResTask.success) {
        this.Task_FIN = ResTask.operation;
        Loader.classList.remove('active');

        const DataTask: any = ResTask.operation;

        if (DataTask.Status != 1) {
          Swal.fire({
            title: 'Ya no puedes revisar esta tarea ',
            text: '¡Esta tarea ya se ha revisado anteriormente!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          }).then((result) => {
            this.NavigateToTasksList();
          })

        }
      }


    } catch (e) {

      this.NavigateToTasksList();
      Swal.fire({
        title: 'Ocurrió un error Buscar la tarea del Proceso',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })


      Loader.classList.remove('active');
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR FORMAT DATE ASSIGNED ==================-\\
  public GetDate_Assigned(Date_Assigned: Date | null): string {
    return moment(Date_Assigned).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================== FUNCTTION FOR SEE FILE FIN IN LIBRARY ==================-\\
  public SeeFINLibrary(): void {
    const rawRoute: string = String(this.Task_FIN.Route_Destination || '').trim();
    const normalizedRoute: string = rawRoute.replace(/\\/g, '/').replace(/^\/+|\/+$/g, '');

    const routeParts: string[] = normalizedRoute.split('/').filter(Boolean);

    // La API puede incluir "RAIZ" como prefijo visual; en navegación real equivale a root.
    if (routeParts.length > 0 && /^raiz$/i.test(routeParts[0])) {
      routeParts.shift();
    }

    const lastPart = routeParts[routeParts.length - 1] || '';
    const looksLikeFile = /\.[a-z0-9]{1,10}$/i.test(lastPart);
    if (looksLikeFile) {
      routeParts.pop();
    }

    const RouteSend: string = routeParts.join('/');

    if (!RouteSend) {
      this.router.navigate([this.baseRoute]);
      return;
    }

    const queryParams: any = {
      path: RouteSend,
      openProperties: 1,
      documentId: this.Task_FIN.ID_WF,
      documentName: this.Task_FIN.Name
    };

    if (this.librarySlug !== 'fin') {
      this.router.navigate(['Dashboard/Lib', this.librarySlug], { queryParams });
      return;
    }

    const RouteEncode: string = encodeURIComponent(RouteSend);
    this.router.navigate([`Dashboard/FIN/FMLibraryFIN/${RouteEncode}`], { queryParams });
  }


  //-======================== DOWNLOAD FILE FIN ========================-\\
  public async DownloadFile(): Promise<void> {

    const Btn_Download = document.getElementById('Btn-Download') as HTMLDivElement;
    Btn_Download.classList.add('active');

    const Progress_Bar_Task = document.getElementById('Progress-Bar-Task') as HTMLSpanElement;

    const Text_Btn = document.getElementById('Text-Btn') as HTMLElement;
    const Icon_Btn = document.getElementById('Icon-Btn') as HTMLElement;

    try {
      const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_FIN({ ID_FIN: this.Task_FIN.ID_WF, Type_D: Download_Log_FIN.D_SPECIFIC_TASK }, this.librarySlug));

      if (ResGetURLFIN.success) {
        const URL = ResGetURLFIN.operation.URL_FIN;

        this.Service_FIN.Download_File_FIN(URL, this.Task_FIN.Name).subscribe((Data_Download: Download_CPP) => {


          if (Data_Download.state === "IN_PROGRESS") {
            Progress_Bar_Task.style.width = Data_Download.progress + '%';
          }

          if (Data_Download.state === "DONE") {

            Btn_Download.classList.remove('active');
            Progress_Bar_Task.style.width = '0%';
            Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-check-double');
            Text_Btn.innerHTML = 'Completada';

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: 'Proceso descargado!'
            })

          }


          if (Data_Download.Status === 404 || Data_Download.Status === 500) {

            Btn_Download.classList.remove('active');
            Progress_Bar_Task.style.width = '0%';
            Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
            Text_Btn.innerHTML = 'Error';

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'error',
              title: '¡Error al descargar el Proceso, informa a tu supervisor!'
            })

            Btn_Download.classList.remove('active');
            Progress_Bar_Task.style.width = '0%';

          }

        })

      }

    } catch (e) {
      Btn_Download.classList.remove('active');
      Progress_Bar_Task.style.width = '0%';
      Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
      Text_Btn.innerHTML = 'Error';
      Swal.fire({
        title: 'Error',
        text: '¡ha ocurrido un error, intente recargar la página, si el problema persiste informe supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTION FOR APPROVED FIN ==================-\\
  public ApproveFIN(): void {

    Swal.fire({
      title: '¿Ha revisado y aprobado el proceso y sus anexos?',
      text: "¡Antes de aprobar una tarea tendrá que revisarla!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, aprobar!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        const Loader = document.getElementById('Loader') as HTMLDivElement;
        Loader.classList.add('active');


        try {

          const ResApproved: any = await firstValueFrom(this.Service_FIN.Approve_Task({ ID: this.Task_FIN.ID }, this.librarySlug));

          if (ResApproved.success) {

            Loader.classList.remove('active');
            Swal.fire({
              icon: 'success',
              title: 'Ha aprobado la tarea',
              timer: 3000,
              confirmButtonColor: this.ColorConfirm
            }).then((result) => {
              this.NavigateToTasksList();
            })

          }

        } catch (e) {

          Loader.classList.remove('active');
          Swal.fire({
            title: 'Ocurrió un error al aprobar la tarea',
            text: '¡Notifique este error al supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })
        }

      }
    })
  }


  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTION FOR REJECT FIN =====================&\\

  //-================== FUNCTION FOR SAVE REASON REJECT ==================-\\
  public SaveReject(): void {

    const IsValidForm = this.ValidationFormReject();

    if (this.FormReject.valid && IsValidForm) {

      const Reason: string = this.FormReject.controls['ReasonText'].value;

      Swal.fire({
        title: '¿Desea enviar la razón de rechazo?',
        text: `¡No podrá revertir cambios!`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, enviar!',
        cancelButtonText: 'No, cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿está seguro?',
            text: `¡Marque la casilla para confirmar el envió de la razón de rechazo!`,
            input: 'checkbox',
            inputPlaceholder: 'Enviar razón de rechazo',
            confirmButtonText: 'Continuar <i class="fa-solid fa-arrow-right"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then(async (resultRem) => {

            if (resultRem.value === 1) {

              try {

                const ResRejectTask: any = await firstValueFrom(this.Service_FIN.Rejected_Task({ ID: this.Task_FIN.ID, Reason: Reason }, this.librarySlug));

                if (ResRejectTask.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Proceso rechazado',
                    confirmButtonColor: this.ColorConfirm,
                  })
                  this.ToggleModalReasonReject(false);
                  this.NavigateToTasksList();
                }

              } catch (e) {
                Swal.fire({
                  title: 'Ocurrió un error al rechazar la tarea',
                  text: '¡Notifique este error al supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.ToggleModalReasonReject(false);
                this.NavigateToTasksList();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para enviar la razón de rechazo !',
                confirmButtonColor: this.ColorConfirm
              })
            }
          })
        }
      })
    }
  }

  //-================== FUNCTION FOR VALIDATE FORM ==================-\\
  private ValidationFormReject(): boolean {

    const IdTextAreaRejectFIN = document.getElementById('IdTextAreaRejectFIN') as HTMLTextAreaElement; IdTextAreaRejectFIN.classList.remove('Is-Invalid-Form');

    if (!this.FormReject.controls['ReasonText'].valid) {
      IdTextAreaRejectFIN.classList.add('ng-invalid'); IdTextAreaRejectFIN.classList.add('ng-touched');

      if (this.FormReject.controls['ReasonText'].value == '') {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡Ingresa una razón de rechazo!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      } else {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡La razón de rechazo es muy corta!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      }

    }

    return true;
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL REASON REJECT ==================-\\
  public ToggleModalReasonReject(CloseOrOpen: boolean): void {
    const ModalReject = document.getElementById('ModalReject') as HTMLDivElement;
    CloseOrOpen ? ModalReject.classList.add('active') : ModalReject.classList.remove('active');
  }

  //&===================== END FUNCTION FOR REJECT FIN =====================&\\


  //&============== FUNCTION FOR OPEN OR CLOSE MODAL, FOR SEE ANNEXE ==============&\\

  //-================== FUNCTTION FOR CUT NAME ==================-\\
  public Modal_See_Annexe(CloseOrOpen: boolean): void {
    const Modal_See_Annexe = document.getElementById('Modal-See-Annexe') as HTMLDivElement;
    CloseOrOpen ? Modal_See_Annexe.classList.add('active') : Modal_See_Annexe.classList.remove('active');
  }

  //-================== FUNCTTION FOR CUT NAME ==================-\\
  public CutNameFile(Name: string, length: number): string {

    if (Name !== undefined) {
      if (Name.length > length) {
        const Ext = Name.split('.').pop();
        const NameCut = Name.slice(0, length);
        return NameCut + '....' + Ext;
      } else {
        return Name;
      }

    } else {
      return '';
    }
  }


  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  public async Get_Download_Annexe(Annexe: Annexe): Promise<void> {

    try {

      const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_Annexe_FIN({ ID_Annexe: Annexe.ID, Type_D: Download_Log_FIN.D_ANNEXE_FILE_M }, this.librarySlug));

      if (ResGetURLFIN.success) {

        const URL = ResGetURLFIN.operation.URL_Annexe;

        const IsDownload = this.Download_Annexe_FIN(URL, Annexe.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el anexo del Proceso, informa a tu supervisor!'
      })
    }

  }

  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  private async Download_Annexe_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const Container_Download_Annexe = document.getElementById('Container-Download-Annexe') as HTMLDivElement;
      const Progress_Bar_Annexe = document.getElementById('Progress-Bar-Annexe') as HTMLDivElement;

      Container_Download_Annexe.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Annexe.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Anexo descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el anexo del Proceso, informe a su supervisor!'
          })

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  //&============== END FUNCTION FOR OPEN OR CLOSE MODAL, FOR SEE ANNEXE ==============&\\

  //-======================== PREVIEW FILE FIN ========================-\\
  public async PreviewFile(event?: Event): Promise<void> {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    if (Loader) Loader.classList.add('active');

    try {
      const res: Response_FIN = await firstValueFrom(
        this.Service_FIN.Get_URL_Download_FIN(
          { ID_FIN: this.Task_FIN.ID_WF, Type_D: Download_Log_FIN.D_SPECIFIC_TASK, isPreview: true },
          this.librarySlug
        )
      );

      if (Loader) Loader.classList.remove('active');

      if (!res.success) {
        throw new Error('No se pudo resolver la URL de la vista previa.');
      }

      this.previewFileUrl = String(res.operation?.URL_FIN || '').trim();
      this.previewFileName = this.Task_FIN.Name;
      this.previewFileExtension = this.Task_FIN.Name.split('.').pop() || '';
      this.showPreview = true;
    } catch (e) {
      if (Loader) Loader.classList.remove('active');
      console.error(e);
      Swal.fire('Error', 'No se pudo cargar la vista previa', 'error');
    }
  }

  public DownloadFromPreview(): void {
    this.DownloadFile();
  }

}
